<template>
	<svg :width="width" :height="height" :class="className">
		<use :href="`${symbolId}`"></use>
	</svg>
</template>

<script setup lang="ts">
import {computed} from "vue";

interface Props {
	name: string
	width?: string | number
	height?: string | number
	className?: string
	prefix?: string
}

const props = withDefaults(defineProps<Props>(), {
	width: '24',
	height: '24',
	className: '',
  prefix: 'icon'
})
const symbolId = computed(() => `#${props.prefix}-${props.name}`)
</script>

